module.exports = __webpack_public_path__ + "static/media/22.107bff61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/22.jpg
// module id = 197
// module chunks = 0